import { GetPageProps, UserRegistrationState } from 'hooks/u002/useUserRegistrationHooks';
import { Controller } from 'react-hook-form';
import { AppLogoHeader } from 'templates/AppLogoHeader';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { AgeSelectForm } from 'organisms/u002/AgeSelectForm';
import { UnauthAppFooter } from 'templates/UnauthAppFooter';
import { useEffect } from 'react';
import Cookies from 'js-cookie';

type AgeVerificationProps = GetPageProps<UserRegistrationState, 'AgeVerification'>;

export const AgeVerification: React.FC<AgeVerificationProps> = (props) => {
  const { t: tAuditionForm } = useTranslationWithLang('auditionForm');

  useEffect(() => {
    const savedBirthday = Cookies.get('userBirthday');
    if (savedBirthday) {
      props.setValue('birthday', new Date(savedBirthday));
    }
  }, []);

  const handleBack = () => props.onBack();
  const handleNext = () => {
    const birthDate = props.getValues('birthday');
    if (birthDate) {
      // クッキーに保存（有効期限1日）
      Cookies.set('userBirthday', birthDate.toLocaleDateString('ja-JP'), {
        expires: 1,
        secure: true,
        sameSite: 'strict',
        path: '/',
      });
    }
    props.onNext();
  };
  const savedBirthday = Cookies.get('userBirthday');
  const { control } = props;

  return (
    <>
      <AppLogoHeader />
      <div aria-live="polite">
        <div role="heading" aria-level={1} aria-live="assertive" className="sr-only">
          {tAuditionForm('TU002_061')}
        </div>

        <Controller
          control={control}
          name="birthday"
          render={({ field }) => (
            <AgeSelectForm
              title={tAuditionForm('TU002_061')}
              birthDate={field.value || null}
              onChange={(d) => {
                field.onChange(d);
              }}
              label={tAuditionForm('TU002_101')}
              key={field.value?.toString()}
              nextLabel={tAuditionForm('TU002_047')}
              onNext={handleNext}
              backLabel={tAuditionForm('TU002_048')}
              onBack={handleBack}
              savedBirthday={savedBirthday}
            />
          )}
        />
      </div>
      <UnauthAppFooter />
    </>
  );
};
